<template>
    <b-card no-body>
        <DrawerRepayment ref="drawer_repayment_list" />
        <b-card-header class="p-3 d-flex justify-content-between align-items-center">
                <h3 class="mb-0">Collection</h3>
                <!-- <div class="d-flex align-items-center text-primary">
                    <p class="text-primary">View All</p>
                </div> -->
            </b-card-header>
            <div class="m-3">
                <div class="mb-3">
                    <span class="text-muted text-xs">Status</span>
                    <p class="text-secondary font-weight-600">{{ activeCase.coll_status || "-" }}</p>
                </div>
                <div class="mb-3">
                    <span class="text-muted text-xs">Due Date (Days Left)</span>
                    <div class="d-flex align-items-center text-warning">
                        <span class="font-weight-600">{{ _gHlp.formatMomentDate(activeCase.coll_due_date,'D MMM, YYYY') }}</span>
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" class="ml-2 mr-1" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-24 120v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                        <span class="font-weight-500">2d</span> -->
                    </div>
                </div>
                <div class="mb-3">
                    <span class="text-muted text-xs">Next Repayment</span>
                    <div class="d-flex align-items-center">
                        <p class="font-weight-600">RM {{ activeCase.coll_next_payment_amt | moneyFormatter }}</p>
                        <div 
                            class="text-primary ml-2 cursor-pointer"
                            @click="$refs.drawer_repayment_list.show()"
                        >
                            <span class="text-xs">Details</span>
                            <svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="6" height="18" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <span class="text-muted text-xs">Total Paid Amt.</span>
                    <p class="font-weight-600">RM {{ activeCase.coll_total_paid_amt | moneyFormatter }}</p>
                </div>
            </div>
    </b-card>
</template>
<script>
import DrawerRepayment from '@/views/CreditLoanCase/Drawers/DrawerRepayment'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	components: {
    DrawerRepayment
	},
	computed: {
    ...mapState(useLoanCaseStore, ['activeCase']),
	}	
}
</script>